import { useState, useEffect } from 'react'
import { getTypeYearAPI } from '../services/contract'

function UseTypeYearSearch() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getTypeYearAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.year, label: d.year }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}
export default UseTypeYearSearch
